import * as React from 'react';
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { appointementGetById } from '../../../redux/actions/Files.action';
import { finalBillByType, searchFinalBill } from '../../../redux/actions/Account.action';
import ReactPaginate from 'react-paginate';

export default function AccountInfo() {

    // const { id } = useParams()

    const id = localStorage.getItem('id')


    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        search: '',
    });
    const [selectedOption, setSelectedOption] = useState("");
    const dispatch = useDispatch()
    const branchData = useSelector((state) => state.files)
    const billType = useSelector((state) => state.account)


    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        billType?.finalBillByType?.data?.totalCount / postPerPage,
    );

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        dispatch(searchFinalBill(userId, newSearchQuery));
    };

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    }

    useEffect(() => {
        if (id) {
            dispatch(appointementGetById(id));
        }
        if (userId && (!selectedOption || selectedOption === "ALL")) {
            dispatch(finalBillByType(userId, "ALL"));
        } else if (userId && selectedOption) {
            dispatch(finalBillByType(userId, selectedOption));
        }
    }, [id, selectedOption, userId, dispatch]);


    return (
        <>
            <div className="mt-[100px]">
                <div className='row justify-content-between border-b pb-4'>
                    <div className='col-6'>
                        <label className='block'>Patient Name</label>
                        <div className="inline-flex gap-2 !text-gray-600 rounded-3 px-3 border-1 mt-1 items-center">
                            <h6 className="mb-0 text-sm">{branchData?.getAppointmentById?.data?.appointmentData?.firstName} {" "} {branchData?.getAppointmentById?.data?.appointmentData?.lastName}</h6>
                            <h6 className="border-l-[1px]  text-sm mb-0 py-2 px-2 !border-[#dadada] ">
                                +91 {branchData?.getAppointmentById?.data?.appointmentData?.phoneNumber}
                            </h6>
                        </div>
                    </div>
                    <div className='col-6 text-end'>
                        <div className='flex justify-end gap-3 font-medium text-lg'>
                            <label className='text-center block text-gray-600 border-r pe-3'><span> Net Amount :</span> <span className='ms-1 border-b border-gray-600'>{billType?.finalBillByType?.data?.totalAmountSum}</span></label>
                            <label className='text-center block text-success border-r pe-3'><span>Received Amount : </span> <span className='ms-1 border-b border-success'>{billType?.finalBillByType?.data?.totalPaidAmountSum}</span></label>
                            <label className='text-center block text-danger'><span>Pending Amount : </span> <span className='ms-1 border-b border-danger'>{billType?.finalBillByType?.data?.totalPendingAmountSum}</span></label>
                        </div>
                    </div>
                </div>

                <div className='row mt-4 mb-5'>
                    <div className="col-lg-3">
                        <div className='flex items-center'>
                            <input type="text" name="search" value={searchQuery} onChange={handleSearch} placeholder='Search ...' className='border outline-none focus:border-theme-dark py-2 px-3 rounded-lg' />
                        </div>
                    </div>
                    <div className="col-lg-9 text-end">
                        <div className='ms-4'>
                            <select
                                onChange={handleChange} value={selectedOption || 'ALL'}
                                className="ms-2 border w-[200px] px-2 py-2 rounded-md focus:outline-none"
                            >
                                <option value="" selected>Filter</option>
                                <option value="ALL">All</option>
                                <option value="CONSULTANT">Consultation</option>
                                <option value="FILECHARGE">File Charge</option>
                                <option value="SERVICE">Services</option>
                                <option value="PACKAGE">Package</option>
                            </select>
                        </div>
                    </div>
                </div>

                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Sr No.</Th>
                                <Th>Date</Th>
                                <Th>Bill No.</Th>
                                <Th>Bill Type</Th>
                                <Th>Service Name</Th>
                                <Th>Remark</Th>
                                <Th>Discount (%)</Th>
                                <Th>Discount (₹)</Th>
                                <Th>Net Amount</Th>
                                <Th>Received Amount</Th>
                                <Th>Due Amount</Th>
                                <Th>Credit Note</Th>
                                <Th>User</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                billType?.finalBillByType?.data?.Billings?.length > 0 ? (
                                    billType?.finalBillByType?.data?.Billings?.map((res, index) => {
                                        return (
                                            <Tr key={res._id}>
                                                <Td>{index + 1}</Td>
                                                <Td>{new Date(res.date).toLocaleDateString('en-GB')}</Td>
                                                <Td>{res.billNumber}</Td>
                                                <Td>{res.type}</Td>
                                                <Td>{res.serviceName || res.packageName || '-'}</Td>
                                                <Td>{res.finalBilling?.billRemark}</Td>
                                                <Td>{res.serviceDiscount || res.packageDiscount || res.filechargeDiscount || res.consultationDiscount || '-'}</Td>
                                                <Td>{res.serviceDiscountRs || res.packageDiscountRs || res.filechargeDiscountRs || res.consultationDiscountRs || '-'}</Td>
                                                <Td>{res.totalAmount > 0 ? res.totalAmount : res.serviceRate || res.serviceTotal || res.type === 'PACKAGE' && res.serviceRate}</Td>
                                                <Td>{res.finalBilling?.paidAmount}</Td>
                                                <Td>{res.totalAmount - res.finalBilling?.paidAmount || res.serviceTotal - res.finalBilling?.paidAmount || 0}</Td>
                                                <Td>Note</Td>
                                                <Td>{res.billGenerateBy}</Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={12} textAlign={'center'}>No Any Bill</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer >
            </div >
        </>
    );
}
